import React from 'react';
import ProductPatternPage from './ProductPatternPage';
import './FrenchBeansPage.css';
import frenchbeansLogo from '../images/frenchbeans-logo.png';

const varieties = [

  // {
  //   name: 'RIYA BEANS (NEW VARIETY)',
  //   image: polebeansLogo,
  //   description: [
  //     'Staking bean with excellent fruit quality and transportability',
  //     'Plant type: Strong and vigorous',
  //     'Pod colour: Dark green',
  //     'Pod type: Attractive slender smooth pod',
  //     'Pod length: 14-16 cm',
  //     'Days for first picking: 40-45 DAS',
  //     'Shelf life: 7-8 days',
  //   ],
  // },
];

export default function FrenchBeansPage() {
  return <ProductPatternPage title="French Beans" varieties={varieties} pageClass="frenchbeans-page" heroImage={frenchbeansLogo} />;
}
